<style lang="less" scoped>
@import '@/style/index.less';
.collection-list{
  width: 100%;
  margin-top: 16px;
  .collection-list-title{
    display: flex;
    justify-content: space-between;
    p{
      padding: 8px 8px;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>

<template>
  <div class="collection-list" >
    <div class="collection-list-title">
      <p>诉讼操作记录</p>
    </div>
    <ListView ref="list-view" :complex-list="mainData" :option="listOption" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ComplexList } from 'complex-data'
import { reactiveLayout } from '@/plugin'
import ListView from '@/components/data/ListView'
import systemApi from '@/pages/index/api/system'
import { listWidth } from '@/config/dictionary/config'

export class OperateList extends ComplexList {}

export default defineComponent({
  name: 'OperateList',
  components: {
    ListView
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      mainData: new OperateList({
        name: '操作记录',
        prop: 'operateList',
        module: {
          dictionary: {
            layout: {
              default: {
                grid: 12,
                label: 8,
                content: 16
              }
            },
            option: {},
            propData: {
              id: 'id'
            },
            list: [
              {
                prop: 'id',
                name: 'ID',
                originProp: 'id',
                originFrom: 'list',
                mod: {}
              },
              {
                prop: 'operation',
                name: '操作名称',
                originProp: 'operation',
                originFrom: 'list',
                mod: {
                  list: {
                    width: listWidth.getWidth(20)
                  }
                }
              },
              {
                prop: 'method',
                name: '方法',
                originProp: 'method',
                originFrom: 'list',
                mod: {}
              },
              {
                prop: 'params',
                name: '参数',
                originProp: 'params',
                originFrom: 'list',
                mod: {}
              },
              {
                prop: 'remark',
                name: '备注',
                originProp: 'remark',
                originFrom: 'list',
                mod: {}
              },
              {
                prop: 'updateBefore',
                name: '无',
                originProp: 'updateBefore',
                originFrom: 'list',
                mod: {}
              },
              {
                prop: 'updateAfter',
                name: '无',
                originProp: 'updateAfter',
                originFrom: 'list',
                mod: {}
              },
              {
                prop: 'createdTime',
                name: '操作时间',
                originProp: 'createdTime',
                originFrom: 'list',
                mod: {
                  list: {
                    width: listWidth.time
                  }
                }
              },
              {
                prop: 'updatedTime',
                name: '无',
                originProp: 'updatedTime',
                originFrom: 'list',
                mod: {}
              },
              {
                prop: 'createdBy',
                name: '创建人id',
                originProp: 'createdBy',
                originFrom: 'list',
                mod: {}
              },
              {
                prop: 'updatedBy',
                name: '无',
                originProp: 'updatedBy',
                originFrom: 'list',
                mod: {}
              },
              {
                prop: 'businessId',
                name: '业务id',
                originProp: 'businessId',
                originFrom: 'list',
                mod: {}
              },
              {
                prop: 'username',
                name: '人员名称',
                originProp: 'username',
                originFrom: 'list',
                mod: {}
              },
            ]
          }
        },
        $getData(this: OperateList) {
          return new Promise((resolve, reject) => {
            systemApi.operateLogList.require({
              pageNo: 1,
              pageSize: 10000,
              method: 'litigationRecord',
              businessId: this.$getExtra('litigationRecordId')
            }).then(res => {
              this.$formatList(res.data.data, res.data.totalCount)
              resolve({ status: 'success' })
            }).catch(err => {
              // eslint-disable-next-line no-console
              console.error(err)
              reject(err)
            })
          })
        }
      }),
      listOption: {
        table: {
          optionProps: {
            bordered: true,
            scroll: {
              x: this.getWidth()
            }
          }
        },
        search: false,
        menu: {
          list: []
        }
      }
    }
  },
  computed: {
    width() {
      return this.getWidth()
    },
    operate() {
      return this.mainData.$getStatus('operate') === 'ing'
    }
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (val) {
          this.mainData.$setExtra('litigationRecordId', this.id)
          this.loadData()
        }
      }
    }
  },
  beforeUnmount() {
    this.mainData.$reset()
  },
  methods: {
    getWidth() {
      return reactiveLayout.data.main.width - 16 * 2
    },
    loadData() {
      this.mainData.$reloadData(true)
    }
  }
})
</script>
